var adminreportingTableBind = { table: '=', data: '=' };
var AdminreportingTableController = (function () {
    function AdminreportingTableController($state, settings, env, socket, $scope, Dialog, admin) {
        this.$state = $state;
        this.settings = settings;
        this.env = env;
        this.socket = socket;
        this.$scope = $scope;
        this.Dialog = Dialog;
        this.admin = admin;
        switch (this.table) {
            case 0:
                this.headers = 'Looser Country,Looser ID,Looser CEID,Winner Country,Winner ID,Winner CEID,Effective Date,Expiry Date'.split(',');
                this.columns = 'LS_COUNTRY,LS_PARTNER_ID,LS_PARTNER_CEID,WN_COUNTRY,WN_PARTNER_ID,WN_PARTNER_CEID,EFF_DATE,EXP_DATE'.toUpperCase().split(',');
                break;
            default:
                this.headers = [];
                this.columns = [];
                break;
        }
    }
    AdminreportingTableController.$inject = ['$state', 'settings', 'env', 'socket', '$scope', 'Dialog', 'admin'];
    return AdminreportingTableController;
}());
var AdminreportingTableComponent = (function () {
    function AdminreportingTableComponent() {
        this.bindings = adminreportingTableBind;
        this.templateUrl = 'adminreporting-table-view.html';
        this.controllerAs = 'vm';
        this.controller = AdminreportingTableController;
    }
    return AdminreportingTableComponent;
}());
angular
    .module('application')
    .component('adminreportingTableSection', new AdminreportingTableComponent());

//# sourceMappingURL=adminreporting.table.component.js.map
